<ng-container *ngIf="policyStore?.id">
  <dtc-page-content>
    <ng-container main>
      <dtc-bread-crumbs></dtc-bread-crumbs>

      <apt-h1 class="underline-title">
        <div fxLayout="row" fxLayoutAlign="start center">
          <div fxFlex class="theme-title" [style.color]="theme?.primaryColor">Bind Confirmation</div>
        </div>
      </apt-h1>

      <form [formGroup]="bindForm" (ngSubmit)="openEmailConfirmDialog()">
        <p>Before proceeding, please review and select the required fields below:</p>

        <div>
          <apt-checkbox
            label="You affirm and certify that all the information in this application herein is complete, true and correct to the best of your knowledge and belief."
          >
            <input type="checkbox" name="affirm" formControlName="affirm" required />
          </apt-checkbox>
        </div>

        <div style="margin-top: 8px">
          <apt-checkbox
            label="You confirm that you are authorized to purchase and activate insurance coverage on behalf of the applying organization. "
          >
            <input type="checkbox" name="confirm" formControlName="confirm" required />
          </apt-checkbox>
        </div>

        <div style="margin-top: 8px">
          <apt-checkbox
            label="You understand that your policy will be renewed automatically at the end of this policy term unless you are otherwise notified by Arch Insurance Group Inc. or its affiliate."
          >
            <input type="checkbox" name="legal1" formControlName="legal1" required />
          </apt-checkbox>
        </div>

        <div style="margin-top: 8px">
          <apt-checkbox
            label="You understand and agree that a third party payment processor (the “Payment Processor”) processes the payments for this Policy.  Our current Payment Processor is Paymentus, and your payments are processed by Paymentus. Arch Insurance Group Inc. does not control and is not liable for the security or performance of the Payment Processor."
          >
            <input type="checkbox" name="legal" formControlName="legal" required />
          </apt-checkbox>
        </div>

        <div style="margin-top: 8px">
          <apt-checkbox
            label="When you provide payment information, you represent and warrant that the information is accurate and that you are authorized to use the payment method provided."
          >
            <input type="checkbox" name="legal2" formControlName="legal2" required />
          </apt-checkbox>
        </div>

        <div style="margin-top: 8px">
          <apt-checkbox label="You agree to sign up for autopay.">
            <input type="checkbox" name="autopay" formControlName="autopay" required />
          </apt-checkbox>
        </div>

        <apt-button-footer>
          <ng-container buttonFooterLeft>
            <dtc-button fxHide.lt-sm secondary large (click)="cancelConfirm()">Back</dtc-button>
          </ng-container>

          <ng-container buttonFooterRight>
            <dtc-button
              fxHide.lt-sm
              fxFlex.lt-sm="100"
              [primary]="true"
              type="submit"
              [disabled]="!bindForm.valid"
              [aptTooltip]="bindForm.valid ? '' : 'Please agree to the required options.'"
              tooltipPlacement="top"
              tooltipMaxWidth="matchElm"
              >Confirm and Proceed</dtc-button
            >
          </ng-container>
        </apt-button-footer>

        <div fxHide.gt-xs fxLayout.lt-sm="column" fxLayout.gt-xs="row" [class.mobile-confirm-buttons]="isSmallScreen">
          <dtc-button
            fxFlex.lt-sm="100"
            [primary]="true"
            type="submit"
            [disabled]="!bindForm.valid"
            [aptTooltip]="bindForm.valid ? '' : 'Please agree to the required options.'"
            tooltipPlacement="top"
            tooltipMaxWidth="matchElm"
            >Confirm and Proceed</dtc-button
          >

          <dtc-button fxFlex fxHide.gt-xs secondary (click)="cancelConfirm()" [ngStyle]="{ 'margin-top': '20px' }">
            Back</dtc-button
          >
        </div>
      </form>
    </ng-container>
    <ng-container right>
      <payment-summary [editable]="false" [policyStore]="policyStore" [product]="policyStore.product">
      </payment-summary>

      <contact-box
        [overrideTheme]="d2cTheme"
        [phoneType]="'phoneD2C'"
        [producerId]="policyStore?.policyData?.policy?.agentCd"
      ></contact-box>
    </ng-container>
  </dtc-page-content>
</ng-container>

<quote-preparation
  [agentCode]="policyStore?.policyData?.policy?.agentCd"
  [policyStore]="policyStore"
  [consumerFlow]="true"
></quote-preparation>

<apt-dialog
  title="Confirm Communication Email"
  modal="true"
  [(open)]="showEmailConfirmDialog"
  width="384px"
  [showCloseX]="true"
>
  <ng-container dialogBody>
    <div class="email-confirmation-dialog" [formGroup]="emailConfirmForm">
      <div class="email-confirmation-note">
        <div class="email-confirmation-note-icon">i</div>
        <div class="email-confirmation-note-text">
          We will use this email address to send important policy-related communications. Please ensure you enter a
          valid and accurate email address.
        </div>
      </div>

      <div class="email-confirmation-field">
        <apt-input label="Email Address" [aptInput]="emailAddressInput" style="width: 100%">
          <input
            #emailAddressInput
            type="email"
            placeholder="abc@company.com"
            formControlName="emailAddress"
            required
          />
        </apt-input>
      </div>

      <div class="email-confirmation-field">
        <apt-input label="Confirm Email Address" [aptInput]="confirmEmailAddressInput" style="width: 100%">
          <input
            #confirmEmailAddressInput
            type="email"
            placeholder="abc@company.com"
            formControlName="confirmEmailAddress"
            required
          />
        </apt-input>
      </div>

      <p class="email-confirmation-error" *ngIf="showEmailMismatchError">Email addresses must match.</p>
      <p class="email-confirmation-error" *ngIf="showInvalidEmailError">Please enter a valid email address.</p>
    </div>
  </ng-container>

  <ng-container dialogFooter>
    <apt-button-footer>
      <ng-container buttonFooterLeft>
        <apt-button secondary="default" (click)="cancelEmailConfirmDialog()">Cancel</apt-button>
      </ng-container>

      <ng-container buttonFooterRight>
        <apt-button
          [primary]="true"
          (click)="proceedToPaymentFromDialog()"
          [disabled]="!emailConfirmForm.valid || !emailsMatch"
          >Proceed</apt-button
        >
      </ng-container>
    </apt-button-footer>
  </ng-container>
</apt-dialog>
